{
  "reviewStatus": "proposal",
  "note": "Spec §19. Tracks are 0–100 and move only through the sources listed here (evidence reducers and authored effects). Relationships gate conversations, activities, support and opportunities — never soccer attributes. Unlock thresholds are owner calls (OPEN_QUESTIONS #20).",
  "tracks": {
    "technical": { "label": "Technical", "movedBy": ["clean touch in trainings, the first-touch drill and park sessions (verified)", "a juggling session with a best run of five or more (+1, verified touches)", "home skill reports (self-reported, small)"] },
    "tactical": { "label": "Tactical", "movedBy": ["sharp or mixed reads in trainings, the first-touch drill and park sessions (verified)", "authored coach conversations"] },
    "physical": { "label": "Physical", "movedBy": ["every match played (+1)"] },
    "wellbeing": { "label": "Wellbeing & recovery", "movedBy": ["rest (+1)", "a hobby session (+1) and a new juggling personal best (+1)", "authored family, friend and hobby scenes"] },
    "school": { "label": "School", "movedBy": ["homework (+1)", "reading every second book night (+1), late gaming every third night (-1)", "authored school and car scenes"] },
    "responsibility": { "label": "Responsibility", "movedBy": ["helping at home (+1)", "kept promises and authored choices"] },
    "pathway": { "label": "Pathway", "movedBy": ["sharp reads in a league match you played (+1)", "a tournament title (+4)", "authored scenes where other clubs notice you"] }
  },
  "unlocks": [
    {
      "id": "friend_park_sessions",
      "title": "Park sessions with your friend",
      "grants": "activity",
      "opens": "A first-touch session at the park with your friend, from the hub on free afternoons and weekends.",
      "requires": [{ "personId": "friend", "min": 20 }]
    },
    {
      "id": "parent_trusts_you",
      "title": "Your parent trusts you with your time",
      "grants": "support",
      "opens": "Park sessions are allowed on school evenings too, and the car rides get more honest.",
      "requires": [{ "personId": "parent", "min": 20 }, { "track": "school", "min": 65 }]
    },
    {
      "id": "coach_extra_feedback",
      "title": "Coach Code offers detailed film feedback",
      "grants": "conversation",
      "opens": "A film-room conversation after league matches, built only from the reads the coach saw.",
      "requires": [{ "personId": "coach", "min": 25 }, { "track": "responsibility", "min": 45 }]
    },
    {
      "id": "captain_conversation",
      "title": "Captaincy conversation",
      "grants": "conversation",
      "opens": "The coach asks you to lead the warm-up — a conversation, not a badge.",
      "requires": [{ "track": "tactical", "min": 45 }, { "track": "responsibility", "min": 60 }]
    },
    {
      "id": "tryout_invitations",
      "title": "Other clubs notice you",
      "grants": "opportunity",
      "opens": "Word gets around before the May tryouts; the season-end conversations change.",
      "requires": [{ "track": "pathway", "min": 30 }]
    }
  ]
}
